import * as React from 'react';
import { useDispatch } from 'react-redux';
import { setPageMeta } from '../pageMeta';
export function usePageMeta(pageMeta) {
  const dispatch = useDispatch();
  React.useState(() => {
    if (global.__CLIENT__) {
      dispatch(setPageMeta({
        pathname: window.location.pathname,
        pageMeta
      }));
    }
  });
}